import React from "react";
import { Button, Navbar } from "react-bootstrap";
import { stringLiterals } from "../../data";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage } from "../../state/slices/message";
import { clearHiringSeasons } from "../../state/slices/hiring";
import { clearApplications } from "../../state/slices/application";
import { clearQuery } from "../../state/slices/query";
import { clearAuth } from "../../state/slices/auth";

// Header including a sign out button
function Header(_props) {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const dispatch = useDispatch();

  const name =
    userInfo.preferredName ||
    userInfo.firstName ||
    userInfo.lastName ||
    userInfo.username ||
    "Not Set";

  const logout = () => {
    dispatch(clearAuth());
    dispatch(clearHiringSeasons());
    dispatch(clearApplications());
    dispatch(clearQuery());
    dispatch(clearMessage());
  };

  return (
    <Navbar
      className="header"
      bg="primary"
      variant="dark"
      sticky="top"
      expand="lg"
    >
      <Navbar.Brand className="custom-brand" href="/">
        {stringLiterals.appTitle}
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse className="justify-content-end">
        <Navbar.Text>
          Signed in as: <a href="/dashboard">{name}</a>{" "}
          <Button
            style={{ marginLeft: "5px" }}
            variant="warning"
            size="sm"
            onClick={logout}
          >
            Sign out
          </Button>
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
